// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Ckle5","carousel":"styles_carousel__2NGlg","scroller":"styles_scroller__3ydm7","left":"styles_left__1Bjfk","right":"styles_right__3yOhZ"};